import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 4);
  const col2 = categories.slice(4, 8);
  const col3 = categories.slice(8, 12);
  const col4 = categories.slice(12);

  return (
    <footer className="bg-secondary-50 text-foreground-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-12">
          <div className="md:max-w-xs">
            <span className="text-xl font-heading font-semibold text-foreground-900 tracking-tight whitespace-nowrap">
              CSSSpreadsheet
            </span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              Your ultimate resource for curated CSSBuy agent spreadsheets and shopping guides.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 flex-1 md:max-w-2xl">
            <div>
              <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Categories 1</p>
              <ul className="space-y-2.5">
                {col1.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Categories 2</p>
              <ul className="space-y-2.5">
                {col2.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Categories 3</p>
              <ul className="space-y-2.5">
                {col3.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">More</p>
              <ul className="space-y-2.5">
                {col4.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                  >
                    Kaspreadsheet
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} CSSSpreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-foreground-900 transition-colors underline whitespace-nowrap"
            >
              Kaspreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-foreground-900 transition-colors underline whitespace-nowrap"
            >
              CSSBuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-foreground-900 transition-colors underline whitespace-nowrap"
            >
              Spreadsheets
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-foreground-900 transition-colors underline whitespace-nowrap"
            >
              Guides
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}